import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
// core components

import { Link } from "gatsby";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import blogStyle from "assets/jss/material-kit-react/views/landingPageSections/blogStyle.jsx";

import mission from "data/mission-hero.json";

class MissionSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgFluid
    );

    return (
      <div id="team" className={classes.section}>
        <GridContainer justify="flex-start">
          <GridItem xs={11}>
          <h2 className={classes.title}>
          Our Mission
          <br/>
          <small className={classes.smallTitle}>{mission.subtitle}</small>
          </h2>
          <Link to="/about#mission-statement">
            <h3>Find out more.</h3>
          </Link>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(blogStyle)(MissionSection);